export default "__VITE_ASSET__CJKq0XCU__"